module.exports = __webpack_public_path__ + "ab165c46b3d547393fa2ac8d89ff36b1.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/kiron-icon-square.png
// module id = ./app/images/kiron-icon-square.png
// module chunks = 35